export const GET_TOOL = 'GET_TOOL';
export const LOADING_TOOL = 'LOADING_TOOL';
export const SAVE_LOADER_TOOL = 'SAVE_LOADER_TOOL'